import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import logoWhite from '/assets/logo-white.png'

const Sidebar = ({ expanded }) => {
  const location = useLocation()
  
  const navigationItems = [
    { icon: 'fas fa-home', label: 'Home', path: '/', active: location.pathname === '/' },
    { icon: 'fas fa-play', label: 'Shorts', path: '/shorts', active: location.pathname === '/shorts' },
    { icon: 'fa-solid fa-photo-film', label: 'Subscriptions', path: '/subscriptions', active: location.pathname === '/subscriptions' },
  ]

  const youSectionItems = [
    { icon: 'fas fa-history', label: 'History', path: '/history', active: location.pathname === '/history' },
    { icon: 'fas fa-list', label: 'Playlists', path: '/playlists', active: location.pathname === '/playlists' },
    // { icon: 'fas fa-video', label: 'Your videos', path: '/studio/content', active: location.pathname === '/studio/content' },
    { icon: 'fas fa-clock', label: 'Watch Later', path: '/watch-later', active: location.pathname === '/watch-later' },
    { icon: 'fas fa-thumbs-up', label: 'Liked videos', path: '/liked-videos', active: location.pathname === '/liked-videos' },
    // { icon: 'fas fa-download', label: 'Downloads' },
    { icon: 'fas fa-cog', label: 'Settings', path: '/settings/account', active: location.pathname.startsWith('/settings') }
  ]

  const studioSectionItems = [
    { icon: 'fas fa-th-large', label: 'Dashboard', path: '/studio/dashboard', active: location.pathname === '/studio/dashboard' },
    { icon: 'fas fa-play', label: 'Your videos', path: '/studio/content', active: location.pathname === '/studio/content' },
    // { icon: 'fas fa-chart-bar', label: 'Analytics', path: '/studio/analytics', active: location.pathname === '/studio/analytics' },
    // { icon: 'fas fa-users', label: 'Community', path: '/studio/community', active: location.pathname === '/studio/community' },
    // { icon: 'fas fa-closed-captioning', label: 'Subtitles', path: '/studio/subtitles', active: location.pathname === '/studio/subtitles' },
    // { icon: 'fas fa-copyright', label: 'Copyright', path: '/studio/copyright', active: location.pathname === '/studio/copyright' },
    // { icon: 'fas fa-dollar-sign', label: 'Earn', path: '/studio/earn', active: location.pathname === '/studio/earn' },
    { icon: 'fas fa-cog', label: 'Studio Settings', path: '/studio/settings', active: location.pathname === '/studio/settings' }
  ]

  const policySectionItems = [
    { icon: 'fas fa-info-circle', label: 'About', path: '/about', active: location.pathname === '/about' },
    { icon: 'fas fa-file-contract', label: 'Terms', path: '/terms', active: location.pathname === '/terms' },
    { icon: 'fas fa-user-shield', label: 'Privacy', path: '/privacy', active: location.pathname === '/privacy' },
    { icon: 'fas fa-shield-alt', label: 'Policies & Safety', path: '/policies', active: location.pathname === '/policies' },
    { icon: 'fas fa-copyright', label: 'Copyright', path: '/copyright', active: location.pathname === '/copyright' }
  ]

  return (
    <aside className={`bg-brown-950 border-r border-gray-500 pt-6 transition-all duration-500 ease-in-out flex-shrink-0 h-full overflow-y-auto scrollbar-hide ${
      expanded ? 'w-56' : 'w-16'
    }`}>

      {/* Main Navigation Section */}
      <div className="space-y-1 px-2">
        {navigationItems.map((item, index) => (
          <Link key={index} to={item.path} className={`flex cursor-pointer items-center rounded-lg px-3 py-2 ${
            item.active ? 'bg-white/20' : 'hover:bg-white/10'
          }`}>
            <div className="w-10 h-10 flex items-center justify-center">
              <i className={`${item.icon} text-lg text-white`}></i>
            </div>
            {expanded && (
              <span className="text-sm text-white font-medium ml-3">
                {item.label}
              </span>
            )}
          </Link>
        ))}
      </div>
      
      {/* Studio Section */}
      <div className="mt-6 pt-6 border-t border-gray-600">
        <div className={`px-4 mb-4 ${expanded ? 'text-left' : 'text-center'}`}>
          <span className="text-sm text-white font-bold">Studio</span>
        </div>
        <div className="space-y-1 px-2">
          {studioSectionItems.map((item, index) => (
            <Link 
              to={item.path || '#'} 
              key={index} 
              className={`flex cursor-pointer items-center rounded-lg px-3 py-2 ${
                item.active ? 'bg-white/20' : 'hover:bg-white/10'
              }`}
            >
              <div className="w-10 h-10 flex items-center justify-center">
                <i className={`${item.icon} text-lg text-white`}></i>
              </div>
              {expanded && (
                <span className="text-sm text-white ml-3">{item.label}</span>
              )}
            </Link>
          ))}
        </div>
      </div>

      {/* You Section */}
      <div className="mt-6 pt-6 border-t border-gray-600">
        <div className={`px-4 mb-4 ${expanded ? 'flex items-center justify-between' : 'text-center'}`}>
          <span className="text-sm text-white font-medium">You</span>
          {expanded && <i className="fas fa-chevron-right text-white text-sm"></i>}
        </div>
        <div className="space-y-1 px-2">
          {youSectionItems.map((item, index) => (
            <Link 
              to={item.path || '#'} 
              key={index} 
              className={`flex cursor-pointer items-center rounded-lg px-3 py-2 ${
                item.active ? 'bg-white/20' : 'hover:bg-white/10'
              }`}
            >
              <div className="w-10 h-10 flex items-center justify-center">
                <i className={`${item.icon} text-lg text-white`}></i>
              </div>
              {expanded && (
                <span className="text-sm text-white ml-3">{item.label}</span>
              )}
            </Link>
          ))}
        </div>
      </div>

    {/* Policy Section */}
      <div className="mt-6 pt-6 border-t border-gray-600">
        <div className={`px-4 mb-4 ${expanded ? 'text-left' : 'text-center'}`}>
          <span className="text-sm text-white font-bold">Legal & Policies</span>
        </div>
        <div className="space-y-1 px-2">
          {policySectionItems.map((item, index) => (
            <Link 
              to={item.path} 
              key={index} 
              className={`flex cursor-pointer items-center rounded-lg px-3 py-2 ${
                item.active ? 'bg-white/20' : 'hover:bg-white/10'
              }`}
            >
              <div className="w-10 h-10 flex items-center justify-center">
                <i className={`${item.icon} text-lg text-white`}></i>
              </div>
              {expanded && (
                <span className="text-sm text-white ml-3">{item.label}</span>
              )}
            </Link>
          ))}
        </div>
      </div>
    </aside>
  )
}

export default Sidebar 